/**
 * Header cart.
 */

/* Imports */
import axios from 'axios';
import cartService from '../services/cart.service';
import globalEventsService from '../services/global-events.service';

/* Assumed jQuery */
const $ = jQuery;

/* The component */
let jqComponent;

/* Data attributes */
let ajaxCartHeaderInnerHtmlUrl;
let ajaxSetArticleQuantityUrl;
let currentUrl;
let checkoutPageUrl;
let maxWidthForNoPopup;
let tagManagerLabel;

/* State */
let active = false;
let loading = false;

/*----------------------------------------------------------------------
 * Exported functions
 */

/**
 * @return void
 */
function init ()
{
    /* Search for cart component, only one */
    jqComponent = $('.component-header-cart');
    if (jqComponent.length == 0) return;

    /* We have component, activate */
    active = true;

    /* Get data attributes */
    ajaxCartHeaderInnerHtmlUrl = jqComponent.data('ajax-cart-header-inner-html-url');
    ajaxSetArticleQuantityUrl = jqComponent.data('ajax-set-article-quantity-url');
    currentUrl = jqComponent.data('current-url');
    checkoutPageUrl = jqComponent.data('checkout-page-url');
    maxWidthForNoPopup = jqComponent.data('max-width-for-no-popup');
    tagManagerLabel = jqComponent.data('tag-manager-label');

    // Añadir event listener al icono del carrito (una sola vez)
    $(document).on('click', '.addmenu__cart', function(e) {
        e.preventDefault();
        open();
    });

    /* Refresh content */
    refresh();
}

/**
 * @return void
 */
function open () {
    jqComponent.addClass('open');
    $('.addmenu__cart').addClass('open'); // Añadir clase open al icono
    $('html').addClass('side-open');
}

/**
 * @return void
 */
function close () {
    jqComponent.removeClass('open');
    $('.addmenu__cart').removeClass('open'); // Remover clase open del icono
    $('html').removeClass('side-open');
}

/**
 * @return void
 */
function quantityButtonClickHanlder (event) {
    let idProducte = $(event.target).data('article-id-producte');
    let idsProducteColor = $(event.target).data('article-ids-producte-color');
    let quantity = $(event.target).data('quantity');

    if(!idProducte || !idsProducteColor || !quantity) {
        idProducte = $(event.target).closest('.carousel__item').find(".addmenu__close").data('article-id-producte');
        idsProducteColor = $(event.target).closest('.carousel__item').find(".addmenu__close").data('article-ids-producte-color');
        quantity = $(event.target).closest('.cart-product-qty').find(".quantity").val();
    }

    if(!quantity) {
        quantity = 0;
    }

    cartService.setArticleQuantity(idProducte, idsProducteColor, quantity);
}

/*----------------------------------------------------------------------
 * Event handlers
 */
globalEventsService.addEventListener(globalEventsService.EVENT_CART_UPDATE,
    (event) => {
        /* Si és pantalla estreta i hem afegit un article, anar directament a la
         * pàgina del carretó; si no, refrescar. */
        if (event.detail.add_article &&
            window.innerWidth > 0 && window.innerWidth <= maxWidthForNoPopup)
        {
            /* Petit retard per a donar temps a esdeveniments tag manager,
             * suposant que el update de la cistella ja retrassa una mica. */
            setTimeout(() => {
                refresh().then(() => {
                    if (event.detail.add_article) {
                        open();
                    }
                });
                //jqComponent.find('.form-to-checkout-page').trigger('submit');
            }, 300);
        } else {
            refresh().then(() => {
                if (event.detail.add_article) {
                    open();
                }
            });
        }
    });

/*----------------------------------------------------------------------
 * Private functions
 */

/**
 * @return void
 */
function refresh ()
{
    if (!active) return;
    return axios.get(ajaxCartHeaderInnerHtmlUrl)
        .then((response) => {
            jqComponent.html(response.data);
            jqComponent.find('.btn-close-cart')
                .on('click', event => close());
            jqComponent.find('.bt-cart-quantity')
                .on('click', quantityButtonClickHanlder);
            jqComponent.find('[name="resume_shopping_url"]').val(currentUrl);
            jqComponent.find('[data-tag-manager-label').attr('data-tag-manager-label', tagManagerLabel);

            // Usar un solo event listener para el documento
            $(document).off('click.outsideCart').on('click.outsideCart', function(event) {
                const cart = document.querySelector(".component-header-cart.open");
                const cartButton = document.querySelector(".addmenu__cart");
                if (cart && !cart.contains(event.target) && !cartButton.contains(event.target)) {
                    close();
                }
            });
        });
}

/*----------------------------------------------------------------------
 * Default export object
 */
export default {
    init,
    open,
    close,
};
